export default __webpack_public_path__ + "static/media/TasksActive.a82c3b91.svg";